import React from 'react';
import { ThemeButton } from './ThemeButton';

interface ThemeToggleProps {
  className?: string;
}

export const ThemeToggle: React.FC<ThemeToggleProps> = ({ className }) => {
  return <ThemeButton className={className} />;
};
